import { AgGridVue } from 'ag-grid-vue'
import gridMixin from '../mixins/gridMixin'
import CompanyMixin from '@/store/module/company/mixin'
import PermissionMixin from '@/store/module/permission/mixin'
import { loading, toast } from '@/shared/utils/UIHelper'
import WorkPositionRepository from '@/shared/http/repositories/business/workPosition'
import PDRItemFormRepository from '@/shared/http/repositories/pci/pdritemform'
import PDRItemFormReportRepository from '@/shared/http/repositories/pci/pdritemformreport'
import PDRWorkPositionReportRepository from '@/shared/http/repositories/pci/pdrworkpositionreport'
import moment from 'moment'

export default {
  name: 'GoalRegistration',
  components: {
    AgGridVue
  },
  mixins: [gridMixin, CompanyMixin, PermissionMixin],
  data () {
    return {
      workPositions: null,
      itemsForm: null,
      showGoalItens: false,
      showGoalFunction: false,
      availableItens: {
        options: []
      },
      availableFunctions: {
        options: []
      },
      availableOperators: [
        {
          value: 1,
          text: '<= (Menor ou igual que)'
        },
        {
          value: 2,
          text: '< (Menor que)'
        },
        {
          value: 3,
          text: '= (igual á)'
        },
        {
          value: 4,
          text: '> (Maior que)'
        },
        {
          value: 5,
          text: '>= (Maior ou igual que)'
        }
      ],
      onGridItem: null,
      itemRowData: [{}],
      itemColumnDefs: [
        {
          headerName: 'Vigência (Início)',
          field: 'inicio',
          minWidth: 150,
          valueGetter: (param) => {
            if (param.data.inicio) {
              return moment(param.data.inicio).startOf('day').toDate().toLocaleDateString()
            }
          }
        },
        {
          headerName: 'Vigência (Término)',
          field: 'termino',
          minWidth: 150,
          valueGetter: (param) => {
            if (param.data.termino) {
              return moment(param.data.termino).startOf('day').toDate().toLocaleDateString()
            }
          }
        },
        {
          headerName: 'Item',
          field: 'pdrFormularioItem.descricao',
          minWidth: 400
        },
        {
          headerName: 'Operação (Item)',
          field: 'operacaoItem',
          minWidth: 150,
          valueGetter: (params) => {
            if (params.data.operacaoItem) {
              return this.availableOperators[params.data.operacaoItem - 1].text
            }
          }
        },
        {
          headerName: 'Meta (Item)',
          field: 'metaItem',
          minWidth: 150
        },
        {
          headerName: 'Operação (Obra)',
          field: 'operacaoObra',
          minWidth: 150,
          valueGetter: (params) => {
            if (params.data.operacaoObra) {
              return this.availableOperators[params.data.operacaoObra - 1].text
            }
          }
        },
        {
          headerName: 'Meta (Obra)',
          field: 'metaObra',
          minWidth: 150,
          valueGetter: (params) => {
            if (params.data.metaObra) {
              return `${params.data.metaObra} %`
            }
          }
        },
        {
          headerName: 'Data de Criação',
          field: 'dataAcaoFormatada',
          minWidth: 150
        }
      ],
      itemGridOptions: {
        groupHeaderHeight: 20,
        headerHeight: 20,
        rowHeight: 20
      },
      onGridFunction: null,
      functionRowData: [{}],
      functionColumnDefs: [
        {
          headerName: 'Vigência (Início)',
          field: 'inicio',
          minWidth: 150,
          valueGetter: (param) => {
            if (param.data.inicio) {
              return moment(param.data.inicio).startOf('day').toDate().toLocaleDateString()
            }
          }
        },
        {
          headerName: 'Vigência (Término)',
          field: 'termino',
          minWidth: 150,
          valueGetter: (param) => {
            if (param.data.termino) {
              return moment(param.data.termino).startOf('day').toDate().toLocaleDateString()
            }
          }
        },
        {
          headerName: 'Função',
          field: 'funcaoObra.nome',
          minWidth: 400
        },
        {
          headerName: 'Operação',
          field: 'operacaoItem',
          minWidth: 150,
          valueGetter: (params) => {
            if (params.data.operacaoItem) {
              return this.availableOperators[params.data.operacaoItem - 1].text
            }
          }
        },
        {
          headerName: 'Meta',
          field: 'metaItem',
          minWidth: 150
        },
        {
          headerName: 'Data de Criação',
          field: 'dataAcaoFormatada',
          minWidth: 150
        }
      ],
      functionGridOptions: {
        groupHeaderHeight: 20,
        headerHeight: 20,
        rowHeight: 20
      },
      goalItemForm: {
        operacaoItem: null,
        metaItem: null,
        operacaoObra: null,
        metaObra: null,
        inicio: null,
        termino: null,
        pdrformularioitemid: null
      },
      goalFunction: {
        operacaoItem: null,
        metaItem: null,
        inicio: null,
        termino: null,
        funcaoobraid: null
      }
    }
  },
  methods: {
    onLoad () {
      loading.push()
      this.getItemFormGoals()
      this.getWorkPositionGoals()
    },
    // Modals to create goals
    showGoalItensModal () {
      if (this.availableItens.options.length === 0) {
        loading.push()
        PDRItemFormRepository.GetAll()
          .then(response => {
            this.itemsForm = response.data.data
            response.data.data.forEach(e => {
              const option = {value: e.id, text: `${e.marcador} - ${e.descricao}`}
              this.availableItens.options.push(option)
            })
          })
          .catch(error => {
            console.log(error)
            toast.error(this.$lang.Common.Alerts.Error)
          })
          .finally(() => {
            loading.close()
          })
      }
      this.showGoalItens = true
    },
    showGoalFunctionModal () {
      if (this.availableFunctions.options.length === 0) {
        loading.push()
        WorkPositionRepository.GetAll()
          .then(response => {
            this.workPositions = response.data.data
            response.data.data.forEach(e => {
              const option = {value: e.id, text: e.nome}
              this.availableFunctions.options.push(option)
            })
          })
          .catch(error => {
            console.log(error)
            toast.error(this.$lang.Common.Alerts.Error)
          })
          .finally(() => {
            loading.close()
          })
      }
      this.showGoalFunction = true
    },
    sendItemForm () {
      console.log(this.goalItemForm)
      let isValid = true
      isValid = isValid && this.formDateValidate(this.goalItemForm)
      isValid = isValid && this.formGoalFatorValidate(this.goalItemForm.metaItem, this.goalItemForm.operacaoItem)
      isValid = isValid && this.formGoalWorkValidate(this.goalItemForm.metaObra, this.goalItemForm.operacaoObra)
      isValid = isValid && this.formIdValidate(this.goalItemForm.pdrformularioitemid)
      if (isValid) {
        loading.push()
        PDRItemFormReportRepository.CreateGoal(this.goalItemForm)
          .then(response => {
            toast.success('Meta cadastrada com sucesso!')
            this.goalItemForm = {
              operacaoItem: null,
              metaItem: null,
              operacaoObra: null,
              metaObra: null,
              inicio: null,
              termino: null,
              pdrformularioitemid: null
            }
            this.showGoalItens = false
            // setTimeout(() => document.location.reload(), 300)
            this.getItemFormGoals()
          })
          .catch(error => {
            console.log(error)
            toast.error(this.$lang.Common.Alerts.Error)
            loading.close()
          })
          .finally(() => {
            // loading.close()
          })
      }
    },
    sendFunctionForm () {
      console.log(this.goalFunction)
      let isValid = true
      isValid = isValid && this.formDateValidate(this.goalFunction)
      isValid = isValid && this.formGoalFatorValidate(this.goalFunction.metaItem, this.goalFunction.operacaoItem)
      isValid = isValid && this.formIdValidate(this.goalFunction.funcaoobraid)
      if (isValid) {
        loading.push()
        PDRWorkPositionReportRepository.CreateGoal(this.goalFunction)
          .then(response => {
            toast.success('Meta cadastrada com sucesso!')
            this.goalFunction = {
              operacaoItem: null,
              metaItem: null,
              inicio: null,
              termino: null,
              funcaoobraid: null
            }
            this.showGoalFunction = false
            this.getWorkPositionGoals()
          })
          .catch(error => {
            console.log(error)
            toast.error(this.$lang.Common.Alerts.Error)
            loading.close()
          })
          .finally(() => {
            // loading.close()
          })
      }
    },
    formDateValidate (form) {
      if (form.inicio && form.termino) {
        let start = Date.parse(form.inicio)
        let end = Date.parse(form.termino)
        if (start > end) {
          toast.error('Data de início não pode ser maior que a data de termino')
          return false
        }
      }
      return true
    },
    formGoalFatorValidate (goal, operator) {
      if (!goal || !operator) {
        toast.error('Valor e operador de meta são obrigatórios')
        return false
      }
      let goalFloat = parseFloat(goal)
      if (goalFloat < 0 || goalFloat > 1) {
        toast.error('Valor da meta deve estar entre 0 e 1')
        return false
      }
      if (goalFloat >= 1 && operator === 4) {
        toast.error('Condição inválida: > 1')
        return false
      }
      if (goalFloat <= 0 && operator === 2) {
        toast.error('Condição inválida: < 0')
        return false
      }
      return true
    },
    formGoalWorkValidate (goal, operator) {
      if (!goal || !operator) {
        toast.error('Valor e operador de meta são obrigatórios')
        return false
      }
      let goalFloat = parseFloat(goal)
      if (goalFloat < 0 || goalFloat > 100) {
        toast.error('Valor da meta deve estar entre 0 e 100')
        return false
      }
      if (goalFloat >= 100 && operator === 4) {
        toast.error('Condição inválida: > 100')
        return false
      }
      if (goalFloat <= 0 && operator === 2) {
        toast.error('Condição inválida: < 0')
        return false
      }
      return true
    },
    formIdValidate (id) {
      if (!id) {
        toast.error('Item ou função são obrigatórios')
        return false
      }
      if (!(/^[0-f]{8}-[0-f]{4}-[0-f]{4}-[0-f]{4}-[0-f]{12}$/).test(id)) {
        toast.error('Item ou função inválido')
        return false
      }
      return true
    },
    // grids of goals created
    getItemFormGoals () {
      PDRItemFormReportRepository.GetAllGoal()
        .then(response => {
          const data = response.data.data
          this.itemRowData = data
        })
        .catch(error => {
          console.log(error)
          toast.error(this.$lang.Common.Alerts.Error)
        })
        .finally(() => {
          loading.close()
        })
    },
    getWorkPositionGoals () {
      PDRWorkPositionReportRepository.GetAllGoal()
        .then(response => {
          const data = response.data.data
          this.functionRowData = data
        })
        .catch(error => {
          console.log(error)
          toast.error(this.$lang.Common.Alerts.Error)
        })
        .finally(() => {
          loading.close()
        })
    },
    onGridItemReady (params) {
      this.onGridItem = params.api
      params.api.expandAll()
      this.$nextTick(() => {
        params.api.sizeColumnsToFit()
      })
    },
    onGridFunctionReady (params) {
      this.onGridFunction = params.api
      params.api.expandAll()
      this.$nextTick(() => {
        params.api.sizeColumnsToFit()
      })
    }
  },
  beforeMount () {
    this.onLoad()
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/pci/goalRegistration/goalRegistration.js